var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { AppBar, AppBarActions, AppBarContent, ColumnLayout, styled } from '@auth0/quantum-product';
import Collapse from '@mui/material/Collapse';
import * as React from 'react';
import { SearchBox } from '../SearchBox';
import { ActionArea } from './ActionArea';
import { HamburgerMenu } from './HamburgerMenu';
import { Logo } from './Logo';
import { NavigationDrawer } from './NavigationDrawer';
import { NavLinks } from './NavLinks';
var HeaderBar = styled(AppBar)(function (_a) {
    var _b;
    var theme = _a.theme, fixed = _a.fixed, slideOut = _a.slideOut;
    return (_b = {
            padding: theme.spacing(0, 3),
            backgroundColor: !fixed || slideOut ? theme.palette.common.white : theme.palette.background.homePage,
            position: fixed ? 'fixed' : 'relative'
        },
        _b[theme.breakpoints.down(theme.layout.tabletBreakpoint)] = {
            padding: 0,
        },
        _b);
});
var HeaderContent = styled(AppBarContent)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            maxWidth: theme.layout.headerFullWidth,
            width: 'inherit',
            padding: 0,
            overflow: 'hidden',
            borderBottom: "0.5px solid ".concat(theme.palette.divider)
        },
        _b[theme.breakpoints.down(theme.layout.tabletBreakpoint)] = {
            maxWidth: '100%',
            padding: theme.spacing(0, theme.layout.mobileMarginX),
        },
        _b);
});
var ColumnStack = styled(ColumnLayout)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            gridTemplateColumns: 'none',
            gridAutoColumns: 'min-content',
            gridAutoFlow: 'column',
            alignItems: 'center'
        },
        _b[theme.breakpoints.up('md')] = {
            gridTemplateColumns: 'none',
        },
        _b);
});
export var Header = function (_a) {
    var currentSection = _a.currentSection, currentRouteName = _a.currentRouteName, sections = _a.sections, _b = _a.isAuthenticated, isAuthenticated = _b === void 0 ? false : _b, user = _a.user;
    var isHomePage = currentRouteName === 'home';
    var _c = __read(React.useState(false), 2), showSearch = _c[0], setShowSearch = _c[1];
    var _d = __read(React.useState(undefined), 2), backgroundColor = _d[0], setBackgroundColor = _d[1];
    var _e = __read(React.useState(false), 2), expandMenu = _e[0], setExpandMenu = _e[1];
    var headerElRef = React.useRef(null);
    var handleScroll = function () {
        if (!headerElRef.current) {
            return;
        }
        var scrollTop = window.scrollY || 0;
        // @TODO - temp
        setBackgroundColor(scrollTop > 553 ? 'white' : undefined);
        setShowSearch(scrollTop > headerElRef.current.offsetHeight);
    };
    var handleMenuToggle = function (force) {
        var shouldExpandMenu = typeof force === 'boolean' ? force : !expandMenu;
        setExpandMenu(shouldExpandMenu);
    };
    React.useEffect(function () {
        if (isHomePage) {
            document.addEventListener('scroll', handleScroll);
            return function () {
                document.removeEventListener('scroll', handleScroll);
            };
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderBar, { slideOut: expandMenu, fixed: isHomePage, ref: function (el) {
                headerElRef.current = el;
            }, style: { backgroundColor: backgroundColor }, "data-search-index": "false" },
            React.createElement(HeaderContent, null,
                React.createElement(AppBarActions, null,
                    React.createElement(ColumnStack, { gutter: 3 },
                        React.createElement(Logo, null),
                        isHomePage ? (React.createElement(Collapse, { in: showSearch },
                            React.createElement(SearchBox, { placement: "header" }))) : (React.createElement(SearchBox, { placement: "header" })))),
                React.createElement(AppBarActions, { sx: { flex: 1, justifyContent: 'flex-end' } },
                    React.createElement(NavLinks, { sections: sections, currentSection: currentSection, onClick: function () { return handleMenuToggle(false); } })),
                React.createElement(AppBarActions, null,
                    React.createElement(ActionArea, { placement: "header", isAuthenticated: isAuthenticated, user: user })),
                React.createElement(HamburgerMenu, { expandMenu: expandMenu, onClick: function () { return handleMenuToggle(); } }))),
        React.createElement(NavigationDrawer, { isAuthenticated: isAuthenticated, user: user, show: expandMenu, onClose: function () {
                setExpandMenu(false);
            }, sections: sections, currentSection: currentSection })));
};
